<template>
	<div class="container">
		<div class="box-01">
			<div @click="uploadImg(1)" class="box01-div">
				<div class="photograph">
					<van-uploader class="photograph1" v-model="fileList1" 
					:multiple="true" 
					:preview-image='false'
						:after-read="afterRead1" capture="camera" accept="image/*" />
				</div>
				<div class="box01-image">
					<img src="../../static/chuangwen/u30.png" />
				</div>
				<div>行为人员人像拍照</div>
				<div class="box01-ico" v-if="curImgType === 1">
					<img src="" alt="">
				</div><!-- 有图片显示，标记为已上传拍照,照片为必填项 -->
			</div>
			<div @click="uploadImg(2)" class="box01-div">
				<div class="photograph">
					<van-uploader class="photograph1" accept='image/jpeg,image/png,image/jpg' v-model="fileList2"
						:preview-image='false' multiple capture="camera" :after-read="afterRead2" />

				</div>
				<div class="box01-image">
					<img src="../../static/chuangwen/u27.png">
					</img>
				</div>
				<div>行为时间现场照片采集</div>
				<div class="box01-ico" v-if="curImgType === 2"></div>
				<!-- 有图片显示，标记为已上传拍照,照片为必填项 -->
			</div>
		</div>

		<div class="grid-photo" v-if="fileList1.length>0">
			<div class="grid-photo-title">行为人员人像：</div>
			<van-uploader accept='image/jpeg,image/png,image/jpg' v-model="fileList1" multiple
				:before-delete="deleteimg1" class="photograph-01" />
		</div>
		<div class="grid-photo" v-if="fileList2.length > 0">
			<div class="grid-photo-title">行为时间现场照片采集：</div>
			<van-uploader accept='image/jpeg,image/png,image/jpg' v-model="fileList2" multiple class="photograph-01" />
		</div>

		<div class="boxtitle">↓↓↓ 行为类别 ↓↓↓</div>
		<div class="box02" v-for="(item,index) in dictList" :key="index">
			<div class="box02-item" :class="activeType === index ? 'on' : ''" @click="xzType(index)">{{item.name}}</div>
			<div class="box02-item-el" v-if="activeType === index">
				{{item.describtion}}
			</div>
		</div>
		<div class="submit_div">
			<button class="submit_btn" @click="submit()">{{cwUser.police === 0 ? '提交' : '提交&处理'}}</button>
		</div>
		<div class="footer">
			<text>版权所有：黄石市大数据信息发展有限公司</text>
		</div>
	</div>
</template>

<script>
	import {
		getDictValList,
		addReport,
		uploadFilechuangwen,
		getCwUser
	} from "@/api/index.js"
	import {
		Toast
	} from 'vant';
	// import {
	// 	getCwUser,
	// 	getDictValList,
	// 	uploadFile,
	// 	addReport,
	// 	locationToAddress
	// } from '../../static/api/chuangwen.js'
	// import commons from '@/requestApi/common.js'
	export default {
		data() {
			return {
				capture: ['camera'],
				activeType: '', // 类别，单选选中
				curImgType: 1, // 两个上传框的当前类别
				cwUser: {}, // 当前创文用户对象
				dictList: [], // 字典值列表
				form: { // 提交表单
					dict_value: '',
					report_user_id: '', // 上报用户id
					people_img_url: '', // 人脸img
					scence_img_url: '', // 场景img
					address: '', // 行为地址
					district: '', // 所属区
				},
				person_img: [], // 行为人照片列表
				time_img: [], // 行为事件照片列表
				location: {
					lat: '',
					lng: '',
				},
				fileList1: [],
				fileList2: [],
				userinfo: {},
				peopleimgarr: [],
				scenceimgarr: [],
				address: {}
			}
		},
		onLoad() {},
		created() {
			this.getLocation()
			this.getDictValList(1)
		},
		mounted() {
			this.getCwUser()
			AlipayJSBridge.call('getItem', {
				key: 'userinfo'
			}, (result) => {
				this.userinfo = JSON.parse(result.userinfo)
				console.log('this.userinfo', this.userinfo)
			});
		},
		methods: {
			//获取创文助手用户数据
			async getCwUser() {
				let params = {}
				let res = await getCwUser(params)
				console.log('获取创文助手用户数据', res)
				this.cwUser = res.result
			},
			async submit() {
				if (!this.validate()) return
				this.form.dict_value = this.dictList[this.activeType].id
				this.form.people_img_url = JSON.stringify(this.peopleimgarr) // 人脸img
				this.form.scence_img_url = JSON.stringify(this.scenceimgarr) // 行为
				this.form.report_user_id = this.cwUser.id // 上报用户id 创文用户id
				console.log('this.form', this.form)
				let res = await addReport(this.form)
				console.log('上传图片', res)
				if (res.code == '0') {
					if (this.cwUser.police == 0) {
						commons.toast('感谢您对创文工作的支持')
						this.gotoIndex()
					} else if (this.cwUser.police == 1 || this.cwUser.police == 2 || this.cwUser.police == 3) {
						// 警察用户，跳转到后面的页面继续处理(1,警察，2辅警，3志愿者及其它)
						this.$router.push({
							path: '/chuangwenChaxun',
							query: {
								rid: res.result,
								uid: this.cwUser.id,
							}
						})
					}
				} else {
					Toast.fail(res.msg)
				}

			},
			//删除回调
			deleteimg1(file, details) {
				this.fileList1.splice(this.fileList1.indexOf(file), 1);
				this.peopleimgarr.splice(details.index, 1)
			},
			deleteimg2(file, details) {
				this.fileList2.splice(this.fileList2.indexOf(file), 1);
				this.scenceimgarr.splice(details.index, 1)
			},
			//上传回调
			afterRead1(file, details) {
				console.log('img1')
				// 此时可以自行将文件上传至服务器
				this.uploadFilechuangwen(file.file, 1)
			},
			afterRead2(file, details) {
				// 此时可以自行将文件上传至服务器
				this.uploadFilechuangwen(file.file, 2)
			},
			//上传图片
			async uploadFilechuangwen(src, num) {
				const formData = new FormData();
				// 通过append方法添加需要的file
				// 这里需要注意 append(key, value)来添加数据，如果指定的key不存在则会新增一条数据，如果key存在，则添加到数据的末尾
				formData.append('uploadFile', src)
				formData.append('word', this.form.address);
				let res = await uploadFilechuangwen(formData)
				console.log('图片上传', res)
				if (res.code == 0) {
					if (num == 1) {
						this.peopleimgarr.push(res.result)
					} else if (num == 2) {
						this.scenceimgarr.push(res.result)
					}
				} else {
					Toast.fail(res.msg)
				}

			},
			//获取定位
			getLocation() {
				AlipayJSBridge.call('getSgaLocation', {}, (result) => {
					console.log('获取定位', result)
					this.form.address = result.address
					this.form.district = result.district
				});
			},
			// 获取字典值列表  行为类别
			async getDictValList(type_id) {
				let params = {
					type_id,
					keyword: ''
				}
				const res = await getDictValList(params)
				console.log('行为类别', res)
				this.dictList = res.result.list
			},


			//图片、行为类别 非空判断
			validate() {
				if (this.fileList1.length === 0 && this.fileList2.length === 0) {
					Toast.fail('请先上传照片')
					return false
				}
				if (!this.activeType) {
					Toast.fail('请选择行为类别')
					return false
				}
				return true
			},
			// 跳转到首页
			gotoIndex() {
				this.$router.push('chuangwenIndex')
			},
			// 批量上传图片接口
			uploadImg(type) {
				this.curImgType = type
			},
			// 当前激活的行为类别
			xzType(index) {
				this.activeType = index;
			},
		}
	}
</script>

<style>
	.container {
		font-size: 14px;
	}

	.box-01 {
		display: flex;
		align-items: center;
		justify-content: space-between;
		box-sizing: border-box;
		margin: 10px 10px 0 10px;
		margin-top: 20px;
		font-size: 13px;
	}

	.box01-div {
		flex: 1;
		color: #FFFFFF;
		background-color: #0079FE;
		text-align: center;
		margin: 8px;
		height: 110px;
		border-radius: 10px;
		position: relative;
	}

	.photograph {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		z-index: 999;
		width: 100%;
		height: 100%;
	}

	.photograph1 {
		width: 100%;
		height: 100%;
	}

	.box01-image {
		height: 75px;
		background-color: #0079FE;
		border-radius: 10px;
		;
		display: flex;
	}

	.box01-image img {
		width: 50px;
		height: 43px;
		margin: auto;
	}

	.box01-ico {
		width: 20px;
		height: 20px;
		background: url('../../static/chuangwen/u17.png') center no-repeat;
		background-size: 100% auto;
		position: absolute;
		right: 10px;
		top: 5px;
	}

	.boxtitle {
		text-align: center;
		margin-top: 20px;
		letter-spacing: 5px;
		;
		color: black;
	}

	.box02 {
		margin: 5px 30px 5px 30px;
	}

	.box02-item {
		background-color: #F2F2F2;
		color: #555555;
		text-align: center;
		/* margin-top: 9px; */
		padding: 10px 0;
		border-radius: 20px;
	}

	.box02-item.on {
		color: #FFFFFF;
		background-color: #0079FE;
		position: relative;
	}

	.box02-item-el {
		color: #FF9900;
		background-color: #FEF7DE;
		padding: 7px 10px;
		text-align: left;
	}

	.box02-item.on::after {
		width: 20px;
		background: url('../../static/chuangwen/u17.png') center no-repeat;
		background-size: 100% auto;
		content: '';
		position: absolute;
		left: 15px;
		top: 0;
		bottom: 0;
	}

	.submit_div {
		display: flex;
	}

	.submit_btn {
		margin: auto;
		width: 50%;
		height: 50px;
		line-height: 50px;
		background-color: #0079FE;
		color: #FFFFFF;
		font-size: 15px;
		border-radius: 10px;
	}

	.footer {
		text-align: center;
		color: #BDBDBD;
		font-size: 13;
		line-height: 20px;
		padding: 10px 0;
		margin-top: 10px;
	}

	.grid-photo {
		overflow: hidden;
		clear: both;
		padding: 10px 18px 0 18px;
		background-color: #F6F6F6;
	}

	.grid-photo-title {
		margin: 0 1%;
		padding: 5px 0;
		color: #0079FE;
		font-weight: bold;
	}

	.grid-photo .grid-photo-item {
		width: 23%;
		margin: 1%;
		height: 64px;
		float: left;
		position: relative;
	}

	.image-guanbi {
		width: 13px;
		height: 13px;
		display: inline-block;
		border-radius: 14px;
		position: absolute;
		top: -3px;
		right: -3px;
		z-index: 1;
		background: url(../../static/chuangwen/error.png) center no-repeat #FF4543;
		background-size: 50% 50%;
	}

	.aimg {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.box01-div .van-uploader__upload {
		width: 100% !important;
		height: 100% !important;
		opacity: 0;

	}

	.photograph-01 .van-uploader__upload {
		display: none !important;
	}

	.van-uploader__wrapper {
		width: 100%;
		height: 100%;
	}

	.van-uploader__preview-image {
		width: 76px !important;
		height: 76px !important;
	}
</style>
